
export class ConfirmChangeEmailRequestModel {
    OldEmail: string;
    NewEmail: string;
    Token: string;
}